import { Donuz } from "@/donuz-js/Donuz";

export default {
  data() {
    return {
      client: {},
      confSenha: ""
    };
  },
  created() {
    this.client = JSON.parse(atob(sessionStorage.getItem(btoa("cliente"))));
  },
  methods: {
    async submit() {
      if (this.client.senha != this.confSenha) {
        M.toast({
          html: "As senhas não conferem",
          classes: "red"
        });
        return false;
      }

      let result = await Donuz.customer.updateCustomer(
        this.client,
        sessionStorage.getItem(btoa("tokenCliente")),
        this.ESTABELECIMENTO.id
      );

      if (result.status == 200) {
        M.toast({
          html: "Senha alterada com sucesso!",
          classes: "green"
        });

        this.client.senha = '';
        this.confSenha = '';
      } else {
        M.toast({
          html: "Não foi possível alterar a senha, tente mais tarde!",
          classes: "red"
        });
      }
    }
  }
};